<template>
  <div style="position: relative;">
    <el-form ref="onlineWorkOrder" :model="formFilter" label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <filter-box :item-width="330" operatorPosition='start'>
        <el-form-item label="工单状态" prop="flowStatus">
          <el-select class="filter-item" v-model="formFilter.flowStatus" :clearable="true" placeholder="工单状态">
            <el-option v-for="item in SysFlowWorkOrderStatus.getList()" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期" prop="createTime">
          <date-range class="filter-item" v-model="formFilter.createTime" :clearable="true" :allowTypes="['day']" align="left" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <template v-if="formId === '2074057865575796736'">
          <el-form-item label="项目名称" prop="projectName">
            <el-input class="filter-item" v-model="formFilter.projectName" placeholder="项目名称" />
          </el-form-item>
          <el-form-item label="合同编号" prop="contractNo">
            <el-input class="filter-item" v-model="formFilter.contractNo" placeholder="合同编号" />
          </el-form-item>
          <el-form-item label="供货方名称" prop="supplierName">
            <el-input class="filter-item" v-model="formFilter.supplierName" placeholder="供货方名称" />
          </el-form-item>
          <el-form-item label="盖章状态" prop="seal">
            <el-select class="filter-item" v-model="formFilter.seal" :clearable="true" placeholder="盖章状态">
              <el-option label="是" :value="true"/>
              <el-option label="否" :value="false"/>
            </el-select>
          </el-form-item>
        </template>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" :disabled="processDefinitionKey == null" @click="onSearch()">查询</el-button>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onReset">重置</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="processDefinitionKey == null" @click="onStartFlow()">新建</el-button>
        <el-button v-if="formId === '1632948664567599104'" slot="operator" type="primary" :size="defaultFormItemSize" @click="onExport" :loading="exportLoading">导出</el-button>
        <el-button v-if="isShow" slot="operator" type="primary" :size="defaultFormItemSize" @click="showExport = true">导出</el-button>
        <el-button v-if="isShow" slot="operator" type="primary" :size="defaultFormItemSize"  @click="handlerDownDoc('https://rongfanjs.com/荣帆最新合同模版版本.zip')">合同模版</el-button>
        <el-button v-if="formId === '2074073357573165056'" slot="operator" type="primary" :size="defaultFormItemSize" @click="handlerDownDoc('https://rongfanjs.com/作废合同确认书.docx')">合同作废附件下载</el-button>
        <el-button v-if="formId === '2074075205860331520'" slot="operator" type="primary" :size="defaultFormItemSize" @click="handlerDownDoc('https://rongfanjs.com/合同终止单.docx')">合同终止附件下载</el-button>
        <el-button v-if="formId === '2074057865575796736'" slot="operator" type="primary" :size="defaultFormItemSize" @click="handlerDownDoc('https://rongfanjs.com/合同管理操作手册.pdf')">操作手册</el-button>
      </filter-box>
    </el-form>
    <el-dialog title="选择项目" :visible.sync="showExport" @opened="getExportProjectList" width="500px" size="small">
      <el-form :model="exportForm" size="small">
        <el-form-item label="项目名称" :label-width="'100px'">
          <el-select v-model="exportForm.projectId" placeholder="请选择项目" style="width: 100%;" filterable size="small">
            <el-option v-for="item in proList" :key="item.id" :label="item.project_name" :value="item.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="showExport = false">取消</el-button>
        <el-button size="small" type="primary" @click="onExportWithProject" :loading="exportLoading">导出</el-button>
      </span>
    </el-dialog>
    </el-form>
    <el-row>
      <el-col :span="24" v-if="formConfig.formQueryTable">
        <CustomTable v-if="processDefinitionKey != null" :ref="formConfig.formQueryTable.variableName"
          :widgetConfig="formConfig.formQueryTable" :formType="formConfig.formType"
          :getTableQueryParams="getTableQueryParams"
          :loadTableDataFunc="listWorkOrder"
          @viewWOrkOrder="onView"
          @handlerWOrkOrder="onSubmit"
          @cancelWOrkOrder="onCancelWorkOrder"
          @handlerRemind="onRemindClick"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import '@/staticDict/flowStaticDict.js';
import { mapGetters, mapMutations } from 'vuex';
import { OnlineFormMixins } from './onlineFormMixins.js';
import CustomTable from '@/views/onlineForm/components/customTable.vue';
import { FlowOperationController, FlowEntryController } from '@/api/flowController.js';
import { Contract } from '@/api/contract';

export default {
  name: 'onlineWorkOrder',
  props: {
    formId: {
      type: String,
      required: true
    },
    entryId: {
      type: String,
      required: true
    },
    isPreview: {
      type: Boolean,
      default: false
    }
  },
  mixins: [OnlineFormMixins],
  components: {
    CustomTable
  },
  data () {
    return {
      processDefinitionKey: undefined,
      processDefinitionName: undefined,
      formFilter: {
        createTime: [],
        flowStatus: undefined,
        projectName: '',
        contractNo: '',
        supplierName: '',
        seal: ''
      },
      formData: {
        formFilterCopy: {
          createTime: [],
          flowStatus:undefined,
          projectName: '',
          contractNo: '',
          supplierName: '',
          seal: ''
        },
        formFilter: {
          createTime: [],
          flowStatus:undefined,
          projectName: '',
          contractNo: '',
          supplierName: '',
          seal: ''
        }
      },
      exportLoading: false,
      isFirst: false,
      showExport: false,
      proList: [],
      exportForm: {
        projectId: null
      }
    }
  },
  created () {
    setTimeout(() => {
      this.isFirst = true
    },2000)
  },
  methods: {
    onReset () {
      this.$refs.onlineWorkOrder.resetFields();
      localStorage.removeItem(this.$route.query.formId + 'search')
      this.onSearch();
    },
    onExport () {
      this.exportLoading = true
      const data = {
        datasourceId: "1632658018648723457",
        pageParam: {
          pageNum: 1,
          pageSize: 10
        },
        filterDtoList: [],
        flowWorkOrderDtoFilter: {
          ...this.formFilter
        }
      }

      let httpCall = this.download('/admin/upms/oaFlowDataCost/fybx/exportExcel', data, '费用报销单.xls');
      httpCall.then(res => {
        this.$message.success('导出成功！');
      }).catch(e => {
        this.$message.error(e);
      }).finally(() => {
        this.exportLoading = false
      })
    },
    getExportProjectList () {
      const info = JSON.parse(localStorage.getItem('userInfo')).data
      if (info.deptId != 13 && info.deptId != 11) {
        let projectNature = null
        if (info.deptId !== '2039573101322178560') projectNature = info.userId === 218 ? '市政' : '水利'
        Contract.getContractProjectList(this, { projectNature }).then(res => {
          this.proList = res.data.dataList.map(item => {
            const obj = {}
            for (var str in item) {
              let newStr = str.split(/(?=[A-Z])/)
              newStr.map(name => name.toLowerCase())
              const key = newStr.map(name => name.toLowerCase()).join('_')
              obj[key] = item[str]
            }
            return obj
          })
        })
      } else {
        Contract.getProjectAll(this, { userId: info.userId }).then(res => {
          this.proList = res.data.dataList.map(item => {
            const obj = {}
            for (var str in item) {
              let newStr = str.split(/(?=[A-Z])/)
              newStr.map(name => name.toLowerCase())
              const key = newStr.map(name => name.toLowerCase()).join('_')
              obj[key] = item[str]
            }
            return obj
          })
        })
      }
    },
    onExportWithProject () {
      if (!this.exportForm.projectId) {
        this.$message.warning('请选择项目')
        return
      }
      this.exportLoading = true
      const project = this.proList.find(item => item.id === this.exportForm.projectId)
      const projectName = project ? project.project_name : ''
      const data = {
        projectId: this.exportForm.projectId
      }
      let httpCall = this.download('/admin/upms/oaContract/exportExcel', data, projectName + '.xls');
      httpCall.then(res => {
        this.$message.success('导出成功！');
        this.showExport = false
      }).catch(e => {
        this.$message.error(e);
      }).finally(() => {
        this.exportLoading = false
      })
    },
    getTableQueryParams (widget) {
      let queryParams = [];
      if (Array.isArray(widget.queryParamList)) {
        queryParams = widget.queryParamList.map(item => {
          let paramValue = this.getParamValue(item.paramValueType, item.paramValue);
          if (paramValue == null || paramValue === '' || (Array.isArray(paramValue) && paramValue.length === 0)) return;
          let temp = {
            tableName: item.table.tableName,
            columnName: item.column.columnName,
            filterType: item.column.filterType,
            columnValue: item.column.filterType !== this.SysOnlineColumnFilterType.RANFGE_FILTER ? paramValue : undefined
          }

          if (item.column.filterType === this.SysOnlineColumnFilterType.RANFGE_FILTER) {
            temp.columnValueStart = Array.isArray(paramValue) ? paramValue[0] : undefined;
            temp.columnValueEnd = Array.isArray(paramValue) ? paramValue[1] : undefined;
          }

          return temp;
        }).filter(item => item != null);
      }

      return queryParams;
    },
    listWorkOrder (params) {
      if (this.isPreview || this.processDefinitionKey == null) return Promise.reject();
      return new Promise((resolve, reject) => {
        params = {
          ...params,
          flowWorkOrderDtoFilter: {
            flowStatus: this.formFilter.flowStatus,
            createTimeStart: Array.isArray(this.formFilter.createTime) ? this.formFilter.createTime[0] : undefined,
            createTimeEnd: Array.isArray(this.formFilter.createTime) ? this.formFilter.createTime[1] : undefined,
            projectName: this.formFilter.projectName,
            contractNo: this.formFilter.contractNo,
            supplierName: this.formFilter.supplierName,
            seal: this.formFilter.seal
          }
        }
        if(params.pageParam.pageNum !== 1 ||  params.filterDtoList.length || JSON.stringify(params.flowWorkOrderDtoFilter)!== '{}' || this.isFirst){
          localStorage.setItem(this.$route.query.formId + 'search',JSON.stringify(params))
        }
        FlowOperationController.listWorkOrder(this, params, {
          processDefinitionKey: this.processDefinitionKey
        }).then(res => {
          res.data.dataList = res.data.dataList.map(item => {
            let initTaskInfo = item.initTaskInfo == null ? {} : JSON.parse(item.initTaskInfo);
            let runtimeTaskInfo = (Array.isArray(item.runtimeTaskInfoList) && item.runtimeTaskInfoList.length > 0) ? item.runtimeTaskInfoList[0] : {};
            return {
              ...item,
              flowStatus: this.SysFlowWorkOrderStatus.getValue(item.flowStatus),
              ...Object.keys(item.masterData || {}).reduce((retObj, key) => {
                retObj['masterTable__' + key] = item.masterData[key];
                return retObj;
              }, {}),
              initTaskInfo,
              runtimeTaskInfo,
              masterData: undefined
            }
          });
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    onSearch () {
      this.formData.formFilterCopy = {
        ...this.formData.formFilter
      }
      console.log(this.formData.formFilterCopy);
      
      this.$refs[this.formConfig.formQueryTable.variableName].refresh();
    },
    onResume () {
      let key = this.$route.fullPath;
      let cacheFormData = this.getOnlineFormCache[key];
        const search = JSON.parse(localStorage.getItem(this.$route.query.formId + 'search'))
        if (search) {
          if(JSON.stringify(search.flowWorkOrderDtoFilter) !== '{}'){
            this.formData.formFilterCopy = {}
            this.formData.formFilter = {}
            this.formFilter.flowStatus = search.flowWorkOrderDtoFilter.flowStatus
            this.formData.formFilterCopy.flowStatus = search.flowWorkOrderDtoFilter.flowStatus
            this.formData.formFilter.flowStatus = search.flowWorkOrderDtoFilter.flowStatus
            this.formData.projectName = search.flowWorkOrderDtoFilter.projectName
            this.formData.formFilterCopy.projectName = search.flowWorkOrderDtoFilter.projectName
            this.formData.contractNo = search.flowWorkOrderDtoFilter.contractNo
            this.formData.formFilterCopy.contractNo = search.flowWorkOrderDtoFilter.contractNo
            this.formData.supplierName = search.flowWorkOrderDtoFilter.supplierName
            this.formData.formFilterCopy.supplierName = search.flowWorkOrderDtoFilter.supplierName
            this.formData.seal = search.flowWorkOrderDtoFilter.seal
            this.formData.formFilterCopy.seal = search.flowWorkOrderDtoFilter.seal
          }
          search.filterDtoList.forEach(item => {
            this.formFilter[item.columnName] = item.columnValue
            this.formData.formFilter[item.columnName] = item.columnValue
            this.formData.formFilterCopy[item.columnName] = item.columnValue
            if(item.columnName.indexOf('time') > -1){
              this.formFilter[item.columnName] = [item.columnValueStart, item.columnValueEnd]
              this.formData.formFilter[item.columnName] = [item.columnValueStart, item.columnValueEnd]
              this.formData.formFilterCopy[item.columnName] = [item.columnValueStart, item.columnValueEnd]
            }
          })
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs[this.formConfig.formQueryTable.variableName].onCurrentPageChange(search.pageParam.pageNum || 1)
            },100)
          })
        }
      if (cacheFormData) {
        this.$nextTick(() => {
          if (Array.isArray(this.dropdownWidgetList)) {
            this.dropdownWidgetList.forEach(dropdownWidget => {
              let dropdownWidgetImpl = this.$refs[dropdownWidget.variableName][0];
              if (dropdownWidgetImpl) {
                dropdownWidgetImpl.onVisibleChange();
              }
            });
          }
          this.formData.formFilter = cacheFormData.formFilter;
          this.formData.formFilterCopy = cacheFormData.formFilterCopy;

          this.$refs[this.formConfig.formQueryTable.variableName].setTableWidget(cacheFormData.tableImpl);
          this.removeOnlineFormCache(key);
        });
      }
    },
    onStartFlow () {
      if (this.isPreview || this.processDefinitionKey == null) return;
      let params = {
        processDefinitionKey: this.processDefinitionKey
      }
      localStorage.setItem(this.processDefinitionKey+'flag',this.processDefinitionKey + '-**false')
      FlowOperationController.viewInitialTaskInfo(this, params).then(res => {
        if (res.data && res.data.taskType === this.SysFlowTaskType.USER_TASK && res.data.assignedMe) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              processDefinitionKey: this.processDefinitionKey,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: '启动流程',
              flowEntryName: this.processDefinitionName,
              operationList: (res.data.operationList || []).filter(item => item.type !== this.SysFlowTaskOperationType.CO_SIGN),
              variableList: res.data.variableList
            }
          });
        } else {
          FlowOperationController.startOnly(this, {
            processDefinitionKey: this.processDefinitionKey
          }).then(res => {
            this.$message.success('启动成功！');
          }).catch(e => {});
        }
      }).catch(e => {});
    },
    onSubmit (row) {
      if (this.isPreview || this.processDefinitionKey == null) return;
      let taskId = (Array.isArray(row.runtimeTaskInfoList) && row.runtimeTaskInfoList.length > 0) ? row.runtimeTaskInfoList[0].taskId : undefined;
      let params = {
        processInstanceId: row.processInstanceId,
        processDefinitionId: row.processDefinitionId,
        taskId: taskId
      }

      FlowOperationController.viewRuntimeTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: true,
              taskId: taskId,
              processDefinitionKey: row.processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: (row.runtimeInitialTask || {}).taskName,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              operationList: (res.data.operationList || []).filter(item => item.type !== this.SysFlowTaskOperationType.CO_SIGN),
              variableList: res.data.variableList
            }
          });
        }
      }).catch(e => {});
    },
    onView (row) {
      if (this.isPreview || this.processDefinitionKey == null) return;
      let params = {
        processInstanceId: row.processInstanceId
      }
      localStorage.setItem(this.processDefinitionKey+'flag',this.processDefinitionKey + '-**true-**' + JSON.stringify(row))
      FlowOperationController.viewInitialHistoricTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            // 在线流程参数配置
            query: {
              serialNo:row.serialNo,
              isRuntime: false,
              processDefinitionKey: row.processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: true,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              flag: false,
              flowStatus: row.flowStatus
            }
          });
        }
      }).catch(e => {});
    },
    onRemindClick (row) {
      FlowOperationController.remindRuntimeTask(this, {
        workOrderId: row.workOrderId
      }).then(res => {
        this.$message.success('催办成功');
      }).catch(e => {});
    },
    onCancelWorkOrder (row) {
      this.$confirm('是否撤销此工单？').then(res => {
        let params = {
          workOrderId: row.workOrderId,
          cancelReason: '主动撤销'
        }

        FlowOperationController.cancelWorkOrder(this, params).then(res => {
          this.$message.success('撤销成功！');
          this.onSearch();
        }).catch(e => {});
      }).catch(e => {});
    },
    handlerDownDoc(url) {
      const ext = (url.split('.').pop() || '').toLowerCase();
      // pdf 浏览器可内联渲染，只能走 window.open
      if (ext === 'pdf') {
        window.open(url, '_blank');
        return;
      }
      // zip/docx 等浏览器无法渲染的文件，走 iframe 静默下载
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = url;
      document.body.appendChild(iframe);
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 2000);
    },
    ...mapMutations(['removeOnlineFormCache'])
  },
  provide () {
    return {
      preview: () => this.isPreview
    }
  },
  computed: {
    ...mapGetters(['getOnlineFormCache']),
    isShow () {
      const flag = this.getUserInfo.deptId == 11 || this.getUserInfo.deptId == 13 || this.getUserInfo.showName === '桑明峰' || this.getUserInfo.showName === '吉树东'
      if (this.formId === '2074057865575796736' && (flag || this.getUserInfo.deptId === '2039573101322178560')) {
        return true
      }
      return false
    }
  },
  mounted () {
    FlowEntryController.viewDict(this, {
      entryId: this.entryId
    }).then(res => {
      this.processDefinitionKey = res.data.processDefinitionKey;
      this.processDefinitionName = res.data.processDefinitionName;
      if (localStorage.getItem(this.processDefinitionKey+'flag')) {
        const flag = localStorage.getItem(this.processDefinitionKey+'flag').split('-**')[1]
        if(flag){
          const row = JSON.parse(localStorage.getItem(this.processDefinitionKey+'flag').split('-**')[2])
          this.onView(row) 
        }else{
          this.onStartFlow() 
        }
      }
    }).catch(e => {
      if (localStorage.getItem(this.processDefinitionKey+'flag')) {
        this.onStartFlow() 
      }
    });
  }
}
</script>

<style>
</style>
